<template>

  <div id="nav" v-if="this.$store.state.isLoggedIn">
    <body class="hold-transition sidebar-mini layout-fixed sidebar-closed">
<div class="wrapper">

  <!-- Preloader -->
  <!-- <div class="preloader flex-column justify-content-center align-items-center">
    <img class="animation__shake" src="dist/img/AdminLTELogo.png" alt="AdminLTELogo" height="60" width="60">
  </div> -->

  <!-- Navbar -->
  <nav class="main-header navbar navbar-expand navbar-white navbar-light">
    <!-- Left navbar links -->
    <ul class="navbar-nav">
      <li class="nav-item">
        <a class="nav-link" data-widget="pushmenu" href="#" role="button"><i class="fas fa-bars"></i></a>
      </li>
    
    </ul>

    <!-- Right navbar links -->
    <ul class="navbar-nav ml-auto">
      <!-- Messages Dropdown Menu -->
      <!-- <li class="nav-item dropdown">
        <a class="nav-link" title="Inactive User List" data-toggle="dropdown" href="#" @click="checkuser">
          <i class="far fa-comments"></i>
          <span class="badge badge-danger navbar-badge"></span>
        </a>
        <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right">
          <div class="dropdown-item" v-for="value in fetchData.NotActiveUser" :key="value">
             <div class="media" action="">
              <img src="img/user3-128x128.jpg" alt="User Avatar" class="img-size-50 img-circle mr-3">
              <div class="media-body">
                <h3 class="dropdown-item-title">
                  {{value.name}}
                  <span class="float-right text-sm text-warning"><button class="btn btn-success"
                     @click="activeUser(value.userId,value.name,value.email,value.mobile,value.department,value.usertype,value.password)">Active</button></span>
                </h3>
                <p class="text-sm">{{value.email}}</p>
                <p class="text-sm text-muted"><i class="far fa-clock mr-1"></i> {{value.duedate}}</p>
              </div>
            </div>
          </div>

                 <div class="dropdown-divider"></div>
                 

        </div>
      </li> -->
      <!-- Notifications Dropdown Menu -->
      <!-- <li class="nav-item dropdown">
        <a class="nav-link" data-toggle="dropdown" href="#">
          <i class="far fa-bell"></i>
          <span class="badge badge-warning navbar-badge">15</span>
        </a>
        <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right">
          <span class="dropdown-item dropdown-header">15 Notifications</span>
          <div class="dropdown-divider"></div>
          <a href="#" class="dropdown-item">
            <i class="fas fa-envelope mr-2"></i> 4 new messages
            <span class="float-right text-muted text-sm">3 mins</span>
          </a>
          <div class="dropdown-divider"></div>
          <a href="#" class="dropdown-item">
            <i class="fas fa-users mr-2"></i> 8 friend requests
            <span class="float-right text-muted text-sm">12 hours</span>
          </a>
          <div class="dropdown-divider"></div>
          <a href="#" class="dropdown-item">
            <i class="fas fa-file mr-2"></i> 3 new reports
            <span class="float-right text-muted text-sm">2 days</span>
          </a>
          <div class="dropdown-divider"></div>
          <a href="#" class="dropdown-item dropdown-footer">See All Notifications</a>
        </div>
      </li> -->
      <li class="nav-item">
        <a class="nav-link" data-widget="fullscreen" href="#" role="button">
          <i class="fas fa-expand-arrows-alt"></i>
        </a>
      </li>
      <!-- <li class="nav-item">
        <a class="nav-link" data-widget="control-sidebar" data-controlsidebar-slide="true" href="#" role="button">
          <i class="fas fa-th-large"></i>
        </a>
      </li> -->
    </ul>
  </nav>
  <!-- /.navbar -->

  <!-- Main Sidebar Container -->
  <aside class="main-sidebar sidebar-dark-primary elevation-4">
    <!-- Brand Logo -->
    <a  class="brand-link">
      <img src="img/logo1.png" alt="AdminLTE Logo" class="brand-image  elevation-3">
      <span class="brand-text font-weight-light" style="color: white;">Goal Tracker</span>
    </a>

    <!-- Sidebar -->
    <div class="sidebar">
      <!-- Sidebar user panel (optional) -->
      <div class="user-panel mt-3 pb-3 mb-3 d-flex">
        <div class="image">
          <span class="text-uppercase" style="color:white">{{username}}</span>
        </div>
        <div class="info">
          <a href="#" class="d-block"></a>
        </div>
      </div>

      <!-- Sidebar Menu -->
      <nav class="mt-2">
        <ul class="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
          <!-- Add icons to the links using the .nav-icon class
            with font-awesome or any other icon font library -->

            <div v-if="this.$store.state.isUserIn==true">
              <li class="nav-item">
                <router-link class="nav-link " to="/dashboard"> <i class="nav-icon fas fa-tachometer-alt"></i>
                  <p>
                    Dashboard
                  </p>
                </router-link>
                
              </li>
              <!-- <li class="nav-item">
                <router-link class="nav-link " to="/full-calendar"> <i class="nav-icon fas fa-tachometer-alt"></i>
                  <p>
                    Calendar
                  </p>
                </router-link>
                
              </li> -->
              <li class="nav-item">
              <router-link class="nav-link " to="/projects"> <i class="nav-icon fas fa-tree"></i>
              <p>
                Business Goals
              </p>
              </router-link>
              </li>

              <li class="nav-item">
                <router-link class="nav-link " to="/task-assign"> <i class="nav-icon far fa-plus-square"></i>
                  <p>
                    Executions
                  </p>
                </router-link>
              </li>
              <!-- <li class="nav-item">
                  <router-link class="nav-link " to="/Entity"> <i class="nav-icon fas fa-tree"></i>
                    <p>
                      Entity
                    </p>
                  </router-link>
                
                </li> -->
              <!-- <li class="nav-item"> -->
            <!-- <router-link class="nav-link " to="/users"> <i class="nav-icon fas fa-tree"></i>
              <p>
                Users
              </p>
            </router-link>
            </li> -->
            </div>

            <!-- manager route here -->
            <div v-if="this.$store.state.isManagerIn==true">
               
              <li class="nav-item">
              <router-link class="nav-link " to="/Manager-dashboard"> <i class="nav-icon fas fa-tree"></i>
              <p>
                Dashboard 
              </p>
              </router-link>
              </li>

              <li class="nav-item">
              <router-link class="nav-link " to="/Manager-kanban-Board"> <i class="nav-icon fas fa-tree"></i>
              <p>
                Manager kanban Board
              </p>
              </router-link>
              </li>

              <li class="nav-item">
              <router-link class="nav-link " to="/Manager-Team"> <i class="nav-icon fas fa-tree"></i>
              <p>
                Team Dashboard
              </p>
              </router-link>
              </li>

              <!-- <li class="nav-item">
              <router-link class="nav-link " to="/Manager-Sub-Project"> <i class="nav-icon fas fa-tree"></i>
              <p>
               Sub Project
              </p>
              </router-link>
              </li> -->

            

              <li class="nav-item">
                <router-link class="nav-link " to="/department"> <i class="nav-icon fas fa-th"></i>
                  <p>
                    Department
                  </p>
                </router-link>
              </li>

              <li class="nav-item">
                <router-link class="nav-link " to="/users-type"> <i class="nav-icon fas fa-copy"></i>
                  <p>
                    Users Type
                  </p>
                </router-link>
              </li>

            <li class="nav-item">
            <router-link class="nav-link " to="/users"> <i class="nav-icon fas fa-tree"></i>
              <p>
                Users
              </p>
            </router-link>
            </li>
            </div>

            <!-- Directore Route Here -->
            <div v-if="this.$store.state.isDirectorIn==true">
                <li class="nav-item">
                  <router-link class="nav-link " to="/Director-dashboard"> <i class="nav-icon fas fa-tachometer-alt"></i>
                    <p>
                      Dashboard 
                    </p>
                  </router-link>
                
                </li>
               
            </div>   
            <!-- ending directore route -->

            <!-- Admin route here -->
            <div v-if="this.$store.state.isAdminIn==true">
              <li class="nav-item">
                  <router-link class="nav-link " to="/Director-Entity"> <i class="nav-icon fas fa-tree"></i>
                    <p>
                      Entity
                    </p>
                  </router-link>
                
                </li>
            </div>
            <!-- Admin route here -->
           
                   
          <li class="nav-item">
            <button class="nav-link" title="Logout" @click="logout()" style="background: wheat;"><i class='fas fa-sign-out-alt' style='font-size:20px;color:red'></i>
            </button>
          </li>
          <br/>
          <!-- <li class="nav-item">
          <div class="teams-share-button" data-href="" data-button-type="medium" data-icon-px-size="160" data-preview="true"></div>
        </li> -->
          
        </ul>
      </nav>
      <!-- /.sidebar-menu -->
    </div>
    <!-- /.sidebar -->
  </aside>

  <!-- Content Wrapper. Contains page content -->
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    
    <!-- /.content-header -->

    <!-- Main content -->
    <!-- <section class="content">
      <div class="container-fluid">
       
      
        <div class="row"> -->
         <!-- main section start -->
         <router-view />

    
        <!-- </div>
      </div>
    </section> -->
    <!-- /.content -->
  </div>
  <!-- /.content-wrapper -->
  <footer class="main-footer">
    <strong>Copyright &copy; 1990-2022 <a href="https://areteservices.in">Areteservices.in</a>.</strong>
    All rights reserved.
    <div class="float-right d-none d-sm-inline-block">
      <b>Version</b> 3.2.0
    </div>
  </footer>

  <!-- Control Sidebar -->
  <aside class="control-sidebar control-sidebar-dark">
    <!-- Control sidebar content goes here -->
  </aside>
  <!-- /.control-sidebar -->
</div>
<!-- ./wrapper -->


</body>
   

  </div>
  <div id="nav" v-else>
    <!-- <button @click="showAlert">Hello world</button> -->

    <router-view />

  </div>

</template>

<script>

import { mapGetters } from "vuex"
  export default {
      name: 'App',
      data() {
        return {
          checklogin:this.$store.state.isLoggedIn,
          sessioncheckdata:'',
          usersdata:this.$store.state.NotActiveUser,
          role:this.$store.state.Role,
          username:localStorage.getItem('Username'),
        }
      },
      components:{
      }, 
      updated(){
        this.username=localStorage.getItem('Username');
      }, 
      mounted(){
      this.userdepartment()

      },
      methods: {
      
        activeUser(id,name,email,mobile,department,usertype,password){
          let payload={
            userId:id,
            name:name,
            email:email,
            mobile:mobile,
            department:department,
            usertype:usertype,
            status:'Active',
            password:password
          }

            this.$store.dispatch('updateUsersdetails',payload);

            this.$swal({
            text: 'User Successfully Active',
            target: '#custom-target',
            customClass: {
              container: 'position-absolute'
            },
            toast: true,
            position: 'top'
            });


        },
        checkuser()
        {
          let dep=localStorage.getItem('department');
          this.$store.dispatch('GetNotActiveUserList',dep);
        },
        logout(){
          this.$store.dispatch('logout');
          if(this.$store.state.isLoggedIn==false)
          {
            this.$router.push('/');

          }
          
        },
        userdepartment(){
          
          let dep=localStorage.getItem('department');
          this.$store.dispatch('GetNotActiveUserList',dep);
          this.username=localStorage.getItem('Username');

        },
    showAlert() {
      // Use sweetalert2
      // this.$toast.show(`Hey! I'm here`);
          this.$swal({
            text: 'Toast with custom target',
            target: '#custom-target',
            customClass: {
              container: 'position-absolute'
            },
            toast: true,
            position: 'top'
        });
    },
  },
      computed: {
        ...mapGetters(['fetchData']),
  },

  }
</script>

<style scoped>
  #app {
      font-family: Avenir, Helvetica, Arial, sans-serif;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      text-align: center;
      color: #2c3e50;
      margin-top: 60px;
  }

  body {
      background-color: #e9ecef;
  }
</style>
